module.exports = __webpack_public_path__ + "static/media/line4.4eaa8444.png";